import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { BELoginComponent } from './be-login/be-login.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { FELoginComponent } from './fe-login/fe-login.component';
import { MobileLoginComponent } from './mobile-login/mobile-login.component';
import { BENoAuthGuard } from './guards/be-no-auth.guard';
import { FENoAuthGuard } from './guards/fe-no-auth.guard';
import { AuthRedirectIfMobileGuard } from './guards/redirect-if-mobile.guard';
import { MFALoginComponent } from './mfa-login/mfa-login.component';
import { TranslateModule } from '@ngx-translate/core';
import { MfaLoginService } from './mfa-login/mfa-login.service';
import { RenewExpiredPasswordComponent } from './renew-expired-password/renew-expired-password.component';
import { CluFeSnackbarService } from 'src/app/@clu-fe/apps/@services/clufe-snackbar.service';

export const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'mobile/login',
                component: MobileLoginComponent
            },
            {
                path: 'cluadmin/login',
                canActivate: [AuthRedirectIfMobileGuard, BENoAuthGuard],
                component: BELoginComponent
            },
            {
                path: 'login',
                canActivate: [AuthRedirectIfMobileGuard, FENoAuthGuard],
                component: FELoginComponent
            },
        ],
    },
];

@NgModule({
    declarations: [
        BELoginComponent, 
        FELoginComponent, 
        MobileLoginComponent, 
        MFALoginComponent, 
        RenewExpiredPasswordComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MaterialModule, 
        FormsModule, 
        ReactiveFormsModule,
        TablerIconsModule.pick(TablerIcons),
        ClipboardModule,
        TranslateModule
    ],
    providers: [
        MfaLoginService,
        CluFeSnackbarService,
    ]
})
export class AuthModule {}
